import { popover_default } from './defaults';
import { Popover } from './types';

export const updatePopoverState = <K extends keyof Popover>(
  state: Popover,
  key: K,
  data: Partial<Popover[K]>
) => {
  const newState = { ...state };
  newState[key] = { ...newState[key], ...data };
  return newState;
};

export const clearPopoverState = <K extends keyof Popover>(state: Popover, key: K) => {
  const newState = { ...state };
  newState[key] = popover_default[key] as Popover[K];
  return newState;
};
